<h2 mat-dialog-title>Shift Schedule Cascade</h2>
<mat-dialog-content>
  <div *ngIf="loading" class="g-just-flex flex-center py-20">
    <mat-spinner diameter="40"></mat-spinner>
    <p class="ml-12">Loading practitioner schedule...</p>
  </div>
  
  <div *ngIf="!loading">
    <form [formGroup]="shiftForm" class="g-just-flex gap-16" style="align-items: center; margin-bottom: 20px;">
      <mat-form-field appearance="outline" style="width: 150px; margin-top: 15px;">
        <mat-label>Shift By (Mins)</mat-label>
        <input matInput type="number" formControlName="shiftMinutes" min="0" step="5">
      </mat-form-field>
      
      <mat-form-field appearance="outline" style="width: 200px; margin-top: 15px;">
        <mat-label>Direction</mat-label>
        <mat-select formControlName="direction">
          <mat-option value="forward">Forward (Delay)</mat-option>
          <mat-option value="backward">Backward (Advance)</mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div *ngIf="proposedChanges.length > 0">
      <h3>Proposed Ripple Effect ({{proposedChanges.length}} appointments affected)</h3>
      <table mat-table [dataSource]="proposedChanges" class="mat-elevation-z2" style="width: 100%;">
        
        <ng-container matColumnDef="patient">
          <th mat-header-cell *matHeaderCellDef> Patient </th>
          <td mat-cell *matCellDef="let element"> {{element.patientName}} </td>
        </ng-container>

        <ng-container matColumnDef="originalTime">
          <th mat-header-cell *matHeaderCellDef> Original Time </th>
          <td mat-cell *matCellDef="let element" class="subtitle-text-color-2" style="text-decoration: line-through;">
            {{element.originalStart | date:'shortTime'}} - {{element.originalEnd | date:'shortTime'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="proposedTime">
          <th mat-header-cell *matHeaderCellDef> Proposed Time </th>
          <td mat-cell *matCellDef="let element" style="font-weight: 500;">
            {{element.proposedStart | date:'shortTime'}} - {{element.proposedEnd | date:'shortTime'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.hasConflict" style="color: red; font-weight: bold; display: flex; align-items: center; gap: 4px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px;">warning</mat-icon> Off-Duty
            </span>
            <span *ngIf="!element.hasConflict" style="color: green; display: flex; align-items: center; gap: 4px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon> OK
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngStyle]="{'background-color': row.hasConflict ? '#ffebee' : ''}"></tr>
      </table>

      <div *ngIf="hasAnyConflicts()" class="warning-box" style="margin-top: 16px; padding: 12px; background-color: #ffebee; border-left: 4px solid #f44336;">
        <strong>Warning:</strong> One or more appointments have been pushed past the practitioner's working hours. If you confirm, they will be scheduled outside of their shift and may need manual rescheduling.
      </div>
    </div>
    
    <div *ngIf="proposedChanges.length === 0 && shiftForm.valid" style="padding: 20px; text-align: center; color: gray;">
      No appointments will be affected.
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="saving">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="loading || shiftForm.invalid || proposedChanges.length === 0 || saving" (click)="submitTransaction()">
    <mat-icon *ngIf="saving">hourglass_empty</mat-icon>
    {{ saving ? 'Saving...' : 'Confirm Shifts' }}
  </button>
</mat-dialog-actions>
